import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { formatSystemDate } from 'src/app/shared/utils/system-date.util';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { forkJoin, Subscription } from 'rxjs';

import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { IFilterContracts, IFilterOptions } from 'src/app/models/filters';
import { HeaderTitle, IHeaderItem, ILot, IPagination, ITransferBatchMassCreatePreview, ITransferBatchMassCreateResult, ModeType } from 'src/app/models/generic';
import { ApiLotsService } from 'src/app/services/api/api-lots.service';
import { DataService } from 'src/app/services/data.service';

import { IFilterBatchSearch } from '../../../models/filters';
import { IGenericResult, IHeaderSummary, ISendBatchEmail, Mode } from '../../../models/generic';
import { IFieldOrder } from '../../../models/manual-batch';
import { ApiDialogService } from '../../../services/api/api-cdialog.service';
import { SnackbarService } from '../../../services/snackbar.service';

@Component({
  selector: 'app-listagem-lotes',
  templateUrl: './listagem-lotes.component.html',
  styleUrls: ['./listagem-lotes.component.scss']
})
export class ListagemLotesComponent implements OnInit, OnDestroy {
  @Input() headerItems: IHeaderItem[] = [];
  @Input() mode!: ModeType;

  title!: HeaderTitle;
  lotsList: ILot[] = [];

  checkedBatches: string[] = [];
  exceptionsBatches: string[] = [];
  queryField = new FormControl<string>('', { nonNullable: true });
  batchDateFrom = new FormControl<string>('', { nonNullable: true });
  batchDateTo = new FormControl<string>('', { nonNullable: true });
  isLegacy = new FormControl<boolean>(false, { nonNullable: false });
  search!: string;
  filters!: IFilterContracts;
  showFilters: boolean = false;
  firsLotsList: boolean = false;
  checkAll: boolean = false;
  fieldsOrder: IFieldOrder[] = [];
  showClipboardCopyTransfer: boolean = false;

  Mode = Mode;

  buildFiltersSubscription!: Subscription;

  count = 0;
  take = 50;
  skip = 0;
  firstLoad: boolean = true;
  isLoadingAutomatic: boolean = false;
  integratedPaymentStatuses: string[] = ['liberado', 'liberado manual', 'liberado parcialmente'];

  get canSendInvoicingEmail(): boolean {
    return this.lotsList.length > 0 && (this.checkedBatches.length > 0 || this.checkAll);
  }

  get canSendTransferEmail(): boolean {
    return this.lotsList.length > 0 && this.hasSelectedTransferBatchesForEmail(false);
  }

  get canSendTransferPaymentEmail(): boolean {
    return this.lotsList.length > 0 && this.hasSelectedTransferBatchesForEmail(true);
  }


  filter: IFilterOptions = {
    toggleFilter: () => (this.showFilters = !this.showFilters)
  };

  constructor(
    private _dataService: DataService,
    private _activatedRoute: ActivatedRoute,
    private _apiLotsService: ApiLotsService,
    private _router: Router,
    private _dialogService: ApiDialogService,
    private _snackbarService: SnackbarService,
    private _clipboardApi: ClipboardService,
    private _datePipe: DatePipe,
    private _currencyPipe: CurrencyPipe,
    private _titleCasePipe: TitleCasePipe,
  ) { }

  ngOnInit(): void {
    this.showClipboardCopyTransfer = this.mode == Mode.Transfer;
    this.firsLotsList = true;
    this.getStorageFilter();
    this.buildFilters();
    this.defineTitle();
    this.buildColumns();
  }

  ngOnDestroy(): void {
    if (this.buildFiltersSubscription)
      this.buildFiltersSubscription.unsubscribe();

  }

  buildColumns(): void {

    if (this.mode == 'transfer') {
      this.headerItems = [
        { label: '', flexSize: 1 },
        { label: 'Status', flexSize: 2 },
        { label: 'Lote', flexSize: 4 },
        { label: 'Banco', flexSize: 4 },
        { label: 'Parceiro', flexSize: 4, name: 'Partner', isOrder: true, orderValue: 0 },
        { label: 'Status do Pagamento', flexSize: 4 },
        { label: 'Data do Lote', flexSize: 4, name: 'CreateDate', isOrder: true, orderValue: 0 },
        { label: 'Data de envio e-mail', flexSize: 4, name: 'EmailTransferDate', isOrder: true, orderValue: 0 },
        { label: 'Data e-mail pgto', flexSize: 4, name: 'EmailEstimatedPaymentDate', isOrder: true, orderValue: 0 },
        { label: 'Valor do Repasse', flexSize: 4, name: 'AmountTotal', isOrder: true, orderValue: 0 },
        { label: 'Qt. de Contratos', flexSize: 4, name: 'NumberOfContracts', isOrder: true, orderValue: 0 },
        { label: 'Status do Lote', flexSize: 4, name: 'StatusOfOnlending', isOrder: true, orderValue: 0 },
        { label: '', flexSize: 1 }
      ];
    }

  }


  toggleFilter(): void {
    this.filter.toggleFilter();
  }

  private getBacthes(pushLots: boolean = false, pagination?: IPagination): void {
    if (this.mode === Mode.Invoicing) {
      this.getInvoicingBatches(pushLots, pagination);
    } else if (this.mode === Mode.Transfer) {
      this.getTransferBatches(pushLots, pagination);
    }
  }

  exportToClipboardTransfer(): void {
    let searchData = {
      StatusOfOnlending: this.filters.StatusOfOnlending,
      OrderStatus: this.filters.OrderStatus,
      BatchStatus: this.filters.BatchStatus,
      Text: this.search,
      Skip: 0,
      Take: 100000,
      BatchDateFrom: this.batchDateFrom.value,
      IsLegacy: this.filters.IsLegacy,
      BatchDateTo: this.batchDateTo.value,
      FieldsOrder: [...this.fieldsOrder]
    } as IFilterBatchSearch;

    this._apiLotsService.getLotsTransfer(searchData).subscribe({
      next: (res: IGenericResult<ILot[]>) => {
        let content: string = 'Status\tLote\tBanco\tParceiro\tStatus do Pagamento\tData do Lote\tData e-mail pgto\tValor do Repasse\tQt. de Contratos\t Status do Lote\r\n';

        if (res.Data.length > 0) {
          res.Data.forEach((lote: ILot) => {
            let status = lote.Active! ? 'Ativo' : 'Cancelado';
            let statusPagamento = (!!lote?.PaymentDate && "Pago") || lote?.SapPaymentStatus || "Pendente";
            let statusLote = (lote?.IntegrationError && "Erro") || lote.BatchStatus || lote.StatusOfOnlending;
            content += `${status}\t ${lote.BatchNumber}\t${this._titleCasePipe.transform(lote?.Bank)}\t${lote?.Partner}\t${statusPagamento}\t${formatSystemDate(lote.CreateDate, 'dd/MM/yyyy')}\t${this._datePipe.transform(lote.EmailEstimatedPaymentDate, 'dd/MM/yyyy') || ''}\t${this._currencyPipe.transform(lote.AmountTotal, 'BRL')}\t${lote.NumberOfContracts}\t${statusLote}\r\n`;
          });

        }

        navigator.clipboard.writeText(content)
          .then(() => {
            this._snackbarService.openSnackBar('Copiado para área de transferência!', 'success');
          });

      }
    });
  }

  exportToClipboardInvoicing(): void {
    let searchData = {
      BatchStatuses: this.filters.BatchStatuses,
      BatchStatus: this.filters.BatchStatus,
      Text: this.search,
      Skip: 0,
      Take: 100000,
      BatchDateFrom: this.batchDateFrom.value,
      BatchDateTo: this.batchDateTo.value,
      IsLegacy: this.filters.IsLegacy,
      FieldsOrder: [...this.fieldsOrder]
    } as IFilterBatchSearch;

    if (this.firsLotsList) {
      searchData.BatchStatuses = [];
    }

    this._apiLotsService.getLotsInvoicing(searchData).subscribe({
      next: (res: IGenericResult<ILot[]>) => {
        let content: string = 'Status\tLote\tStatus de Recebimento\tData do Lote\tData de Recebimento\tData de envio e-mail\tBanco\tValor Faturado\tQt. de Contratos\tStatus Faturamento\r\n';

        if (res.Data.length > 0) {
          res.Data.forEach((lote: ILot) => {
            let status = lote.Active! ? 'Ativo' : 'Cancelado';
            let statusRecebimento = lote?.PaymentDate ? "Pago" : "Pendente";
            let statusFaturamento = (lote?.IntegrationError && "Erro") || lote.BatchStatus || lote.StatusOfOnlending;

            content += `${status}\t ${lote.BatchNumber}\t${statusRecebimento}\t${formatSystemDate(lote.CreateDate, 'dd/MM/yyyy') || ''}\t${this._datePipe.transform(lote.PaymentDate, 'dd/MM/yyyy') || ''}\t${formatSystemDate(lote.EmailInvoiceDate, 'dd/MM/yyyy') || ''}\t${lote.Bank}\t${this._currencyPipe.transform(lote.AmountTotal, 'BRL')}\t${lote.NumberOfContracts}\t${statusFaturamento}\r\n`;
          });

        }

        navigator.clipboard.writeText(content)
          .then(() => {
            this._snackbarService.openSnackBar('Copiado para área de transferência!', 'success');
          });
      }
    });
  }


  private getInvoicingBatches(pushLots: boolean = false, pagination?: IPagination): void {
    let searchData = {
      BatchStatuses: this.filters.BatchStatuses,
      BatchStatus: this.filters.BatchStatus,
      IsLegacy: this.filters.IsLegacy,
      Text: this.search,
      Skip: this.skip,
      Take: this.take,
      BatchDateFrom: this.batchDateFrom.value,
      BatchDateTo: this.batchDateTo.value,
      FieldsOrder: [...this.fieldsOrder]
    } as IFilterBatchSearch;

    if (pagination) {
      searchData = { ...searchData, ...pagination };
    }

    this._apiLotsService.getLotsInvoicing(searchData).subscribe({
      next: (res) => {

        this.firsLotsList = false;
        this.count = res.Count;
        this.firstLoad = false;

        if (pushLots)
          this.lotsList.push(...res.Data);
        else
          this.lotsList = res.Data;

        let summary: IHeaderSummary[] = []

        if (res.Summary != null) {
          summary = [
            { label: 'Lotes:', value: res.Summary.TotalBatchs },
            { label: 'Total de:', value: this._currencyPipe.transform(res.Summary.BatchAmountSum, 'BRL') },
          ];
        }
        this._dataService.setHeaderSummary(summary);

      }
    });
  }

  private getTransferBatches(pushLots: boolean = false, pagination?: IPagination): void {
    let searchData = {
      StatusOfOnlending: this.filters.StatusOfOnlending,
      OrderStatus: this.filters.OrderStatus,
      BatchStatus: this.filters.BatchStatus,
      Text: this.search,
      Skip: this.skip,
      Take: this.take,
      BatchDateFrom: this.batchDateFrom.value,
      IsLegacy: this.filters.IsLegacy,
      BatchDateTo: this.batchDateTo.value,
      FieldsOrder: [...this.fieldsOrder]
    } as IFilterBatchSearch;

    if (pagination) {
      searchData = { ...searchData, ...pagination };
    }

    this._apiLotsService.getLotsTransfer(searchData).subscribe({
      next: (res) => {

        this.firsLotsList = false;
        this.count = res.Count;
        this.firstLoad = false;

        if (pushLots)
          this.lotsList.push(...res.Data);
        else
          this.lotsList = res.Data;

        let summary: IHeaderSummary[] = []

        if (res.Summary != null) {
          summary = [
            { label: 'Lotes:', value: res.Summary.TotalBatchs },
            { label: 'Total de:', value: this._currencyPipe.transform(res.Summary.BatchAmountSum, 'BRL') },
          ];
        }
        this._dataService.setHeaderSummary(summary);

      }
    });
  }

  buildFilters(): void {
    this.buildFiltersSubscription = this._dataService.listFilters.subscribe(
      (filters) => {
        this.filters = filters;

        if (this.firstLoad) {
          let bag = this.mode === Mode.Invoicing ? 'bag_filter_i' : 'bag_filter';
          let storageFilter = localStorage.getItem(bag);

          if (storageFilter != null)
            this.filters = JSON.parse(storageFilter);
          else
            this.filters = this.getDefaultFilters();
        }
        this.resetPagination();
        this.getBacthes();
      }
    );
  }

  searchField(text: string): void {
    let formattedString = text
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '');

    this.search = formattedString;
    this.resetPagination();
    this.getBacthes();
  }

  searchDateField(): void {
    this.skip = 0;
    this.count = 0;

    const bag = {
      dataIni: this.batchDateFrom.value,
      dataFim: this.batchDateTo.value,
      filtros: this.filter
    };

    if (this.mode === Mode.Invoicing) {
      localStorage.setItem('bag_i', JSON.stringify(bag));
    } else if (this.mode === Mode.Transfer) {
      localStorage.setItem('bag_t', JSON.stringify(bag));
    }
    this.getBacthes();
  }

  handlePagination(pagination: IPagination): void {
    this.take = pagination.Take;
    this.skip = pagination.Skip;
    this.getBacthes(true);
  }

  cleanFiltersAndGetLots(): void {
    const filter = this.getDefaultFilters();

    this.queryField.setValue('');
    this.search = '';
    this.take = 50;

    this._dataService.applyFilters(filter);
  }

  private getDefaultFilters(): IFilterContracts {
    return {
      Status: [],
      Stages: [],
      StatusOfOnlending: [],
      OrderStatus: [],
      BatchStatuses: [],
      BatchStatus: true,
      IsLegacy: false,
      IsZeroRate: false,
      WithoutBatch: false,
    };
  }

  defineTitle(): void {
    if (this.mode === 'transfer') {
      this.title = 'Repasse de Comissão';
    } else if (this.mode === 'invoicing') {
      this.title = 'Faturamento dos Contratos';
    }
  }

  insertManualBatch(): void {
    this._dialogService.openManualContractList({}).then((response) => {
      if (response) {
        this._snackbarService.openSnackBar(
          'Novo lote criado com sucesso!',
          'success'
        );
        this._router.navigate([`detalhes-lote-manual-v2`, response.BatchId], {
          relativeTo: this._activatedRoute
        });
      }
    });
  }

  changeInvoiceHeaderCheckbox(): void {

    this.checkAll = !this.checkAll;
    this.checkedBatches = [];
    this.exceptionsBatches = [];

    if (this.mode == Mode.Transfer && this.checkAll)
      this.lotsList
        .filter(lote => !this.disabledCardFlag(lote))
        .forEach(lote => this.handleCheckedBatches(lote.BatchId.toString()));
  }

  checkCardFlag(batch: ILot): boolean {


    if (this.checkAll) {

      if (this.disabledCardFlag(batch)) {
        return false;
      } else {
        return !this.checkExceptionBatchId(batch.BatchId.toString());
      }
    } else {
      return this.checkIncludedBatchId(batch.BatchId.toString());
    }
  }

  disabledCardFlag(batch: ILot): boolean {
    return this.mode === Mode.Invoicing && (!batch.InvoiceNumber || batch.BatchStatus?.toLowerCase() !== 'faturado' || !!batch.AutomaticEmail);
  }

  checkIncludedBatchId(batchId: string): boolean {
    let index = this.checkedBatches.indexOf(batchId);

    return index >= 0 ? true : false;
  }

  checkExceptionBatchId(batchId: string): boolean {
    let index = this.exceptionsBatches.indexOf(batchId);

    return index >= 0 ? true : false;
  }

  changeInvoiceCardCheckbox(batchId: string): void {

    if (this.mode == Mode.Transfer) {
      this.handleCheckedBatches(batchId);
    } else {
      if (!this.checkAll) {
        this.handleCheckedBatches(batchId);
      } else {
        this.handleExceptionsBacthes(batchId);
      }
    }
  }

  handleCheckedBatches(batchId: string): void {
    let index = this.checkedBatches.indexOf(batchId);

    if (index >= 0) {
      this.checkedBatches.splice(index, 1);
    } else {
      this.checkedBatches.push(batchId);
    }
  }

  handleExceptionsBacthes(batchId: string): void {
    let index = this.exceptionsBatches.indexOf(batchId);

    if (index >= 0) {
      this.exceptionsBatches.splice(index, 1);
    } else {
      this.exceptionsBatches.push(batchId);
    }
  }

  handleProcessAutomaticTransferBatches(): void {
    this.isLoadingAutomatic = true;
    this._apiLotsService.getAutomaticTransferBatchesPreview().subscribe({
      next: (response) => {
        this.isLoadingAutomatic = false;
        const preview = response.Data;

        if (!preview || preview.MastersToProcessNow <= 0) {
          const message = preview?.ZeroFeeContractsCount > 0
            ? `Não há contratos elegíveis para gerar lotes no momento. ${preview.ZeroFeeContractsCount} contrato(s) com taxa zerada não serão tratados.`
            : 'Não há contratos elegíveis para gerar lotes no momento.';

          this._snackbarService.openSnackBar(
            message,
            'warning',
            5000
          );
          return;
        }

        const dialogData: IDialogConfirm = {
          type: DialogTypeEnum.Optional,
          appearance: 'modern',
          template: {
            boldTitle: 'Resumo estimado da geração',
            title: this.buildTransferBatchPreviewMessage(preview),
            confirm: 'Sim',
            dismiss: 'Não'
          }
        };

        this._dialogService.openDialog(dialogData).then((confirmResponse) => {
          if (confirmResponse) {
            this.createAutomaticTransferBatches();
          }
        });
      },
      error: (error) => {
        this.isLoadingAutomatic = false;
        const message = error?.error?.Message || 'Erro ao buscar elegibilidade de lotes. Tente novamente.';
        this._snackbarService.openSnackBar(message, 'danger', 5000);
      }
    });
  }

  private buildTransferBatchPreviewMessage(preview: ITransferBatchMassCreatePreview): string {
    const zeroFeeMessage = preview.ZeroFeeContractsCount > 0
      ? `Contratos com taxa zerada que não serão tratados: <strong>${preview.ZeroFeeContractsCount}</strong>.`
      : '';

    return [
      // `Lotes elegíveis no total: <strong>${preview.TotalLots}</strong>.`,
      `Masters elegíveis no total: <strong>${preview.TotalMasters}</strong>.`,
      `Substabelecidos elegíveis no total: <strong>${preview.TotalSubestabelecidos}</strong>.`,
      zeroFeeMessage,
      `Serão processados <strong>${preview.MastersToProcessNow}</strong> masters`,
      '',
      'Deseja continuar?'
    ].join('<br>');
  }

  handleSendInvoiceEmail(payment: boolean): void {

    if (this.mode === Mode.Transfer && !this.hasSelectedTransferBatchesForEmail(payment)) {
      const message = payment
        ? 'Selecione lotes com status Liberado, Liberado Manual ou Liberado Parcialmente.'
        : 'Selecione ao menos um lote apto para Enviar e-mail.';

      this._snackbarService.openSnackBar(message, 'warning');
      return;
    }

    if (this.checkAll || this.checkedBatches.length > 0) {
      const dialogData: IDialogConfirm = {
        type: DialogTypeEnum.Optional,
        appearance: 'modern',
        template: {
          boldTitle: 'Enviar e-mail',
          title:
            'Caso prossiga, o disparo de e-mail será realizado de acordo com os lotes marcados. Deseja continuar?',
          confirm: 'Sim',
          dismiss: 'Não'
        }
      };

      this._dialogService.openDialog(dialogData).then((response) => {
        if (response) {
          this.sendEmail(payment);
        }
      });
    }
  }

  sendEmail(payment: boolean): void {
    const batches: ISendBatchEmail = {
      BatchIds: [...this.checkedBatches],
      ExceptionsBatchIds: [...this.exceptionsBatches],
      SendAll: this.checkAll,
      Filter: {
        BatchStatus: true,
        BatchStatuses: this.filters.BatchStatuses ?? [],
        Text: this.search ?? '',
        Skip: 0,
        Take: 100,
        BatchDateFrom: this.batchDateFrom.value,
        BatchDateTo: this.batchDateTo.value,
        IsLegacy: this.filters.IsLegacy,
        IsZeroRate: this.filters.IsZeroRate,
        WithoutBatch: this.filters.WithoutBatch,
      }
    };

    if (this.mode === Mode.Transfer) {
      batches.BatchIds = this.getSelectedTransferBatchIdsByEmailType(payment);
      batches.SendAll = false;
      batches.ExceptionsBatchIds = [];

      if (batches.BatchIds.length === 0) {
        const message = payment
          ? 'Nenhum lote selecionado está apto para envio de e-mail de pagamento.'
          : 'Nenhum lote selecionado está apto para envio de e-mail.';

        this._snackbarService.openSnackBar(message, 'warning');
        return;
      }
    }

    switch (this.mode) {
      case Mode.Invoicing:
        this.sendInvoiceBatchEmail(batches);
        break;

      case Mode.Transfer:
        if (payment)
          this.sendTransferEstimatedPaymentBatchEmail(batches);
        else
          this.sendTransferBatchEmail(batches);
        break;
    }
  }

  hasSelectedTransferBatchesForEmail(payment: boolean): boolean {
    return this.getSelectedTransferBatchIdsByEmailType(payment).length > 0;
  }

  private getSelectedTransferBatchIdsByEmailType(payment: boolean): string[] {
    if (this.mode !== Mode.Transfer) {
      return [];
    }

    return this.lotsList
      .filter((lot) => this.checkedBatches.includes(lot.BatchId.toString()))
      .filter((lot) => !this.disabledCardFlag(lot))
      .filter((lot) => payment ? this.isIntegratedStatus(lot) : !this.isIntegratedStatus(lot))
      .map((lot) => lot.BatchId.toString());
  }

  private isIntegratedStatus(lot: ILot): boolean {
    const status = (lot.BatchStatus || lot.StatusOfOnlending || '').toLowerCase().trim();
    return this.integratedPaymentStatuses.includes(status);
  }


  createAutomaticTransferBatches(): void {
    this.isLoadingAutomatic = true;
    this._apiLotsService.createAutomaticTransferBatches().subscribe({
      next: (response) => {
        this.isLoadingAutomatic = false;
        this.searchDateField();
        this.handleAfterProcessBatchs(response);
      },
      error: (error) => {
        this.isLoadingAutomatic = false;
        const message = error?.error?.Message || 'Erro ao gerar lotes automáticos. Tente novamente.';
        this._snackbarService.openSnackBar(message, 'danger', 5000);
      }
    });
  }


  sendInvoiceBatchEmail(batches: ISendBatchEmail): void {
    this._apiLotsService.sendInvoiceBatchEmail(batches).subscribe({
      next: (response) => {
        this.handleAfterSendEmail(response);
        this.getInvoicingBatches();
      }
    });
  }

  sendTransferBatchEmail(batches: ISendBatchEmail): void {
    const batchIds$ = batches.BatchIds.map((batchId) => {
      return this._apiLotsService.sendTransferBatchEmail(batchId);
    });

    forkJoin(batchIds$).subscribe({
      next: (response) => {
        this.handleAfterSendEmail(response);
        this.getTransferBatches();
      }
    });
  }

  sendTransferEstimatedPaymentBatchEmail(batches: ISendBatchEmail): void {
    const batchIds$ = batches.BatchIds.map((batchId) => {
      return this._apiLotsService.sendTransferEstimatedPaymentBatchEmail(batchId);
    });

    forkJoin(batchIds$).subscribe({
      next: (response) => {
        this.handleAfterSendEmail(response);
        this.getTransferBatches();
      }
    });
  }

  handleAfterProcessBatchs(response?: IGenericResult<ITransferBatchMassCreateResult>): void {
    const result = response?.Data;
    const message = this.buildTransferBatchResultMessage(result, response?.Message);

    let snackbarType = 'success';

    if (result) {
      if (result.SuccessCount === 0 && (result.FailureCount > 0 || result.EmptyCount > 0)) {
        snackbarType = 'danger';
      } else if (result.FailureCount > 0 || result.EmptyCount > 0) {
        snackbarType = 'warning';
      }
    }

    this._snackbarService.openSnackBar(message, snackbarType);
    this.checkedBatches = [];
    this.exceptionsBatches = [];
    this.checkAll = false;
    this.resetPagination();
  }

  private buildTransferBatchResultMessage(
    result?: ITransferBatchMassCreateResult,
    fallbackMessage?: string
  ): string {
    if (!result) {
      return fallbackMessage || 'Geração de lotes realizada com sucesso!';
    }

    const firstFailureMessage = this.getFirstFailureMessage(result);

    if (result.SuccessCount > 0 && result.FailureCount === 0 && result.EmptyCount === 0) {
      return [
        'Execução concluída com sucesso.',
        `Lotes criados: ${result.SuccessCount}.`
      ].join('\n');
    }

    if (result.SuccessCount > 0) {
      return [
        'Execução concluída parcialmente.',
        `Lotes criados: ${result.SuccessCount}.`,
        `Falhas: ${result.FailureCount}.`,
        `Sem contratos válidos: ${result.EmptyCount}.`,
        firstFailureMessage
      ].filter(Boolean).join('\n');
    }

    if (result.FailureCount > 0) {
      return [
        'Nenhum lote foi criado nesta execução.',
        `Falhas: ${result.FailureCount}.`,
        `Sem contratos válidos: ${result.EmptyCount}.`,
        firstFailureMessage
      ].filter(Boolean).join('\n');
    }

    if (result.EmptyCount > 0) {
      return [
        'Nenhum lote foi criado nesta execução.',
        'Os masters processados não geraram contratos válidos.'
      ].join('\n');
    }

    return fallbackMessage || 'Execução finalizada.';
  }

  private getFirstFailureMessage(result: ITransferBatchMassCreateResult): string {
    const failureMessage = result.Items
      ?.find((item: ITransferBatchMassCreateResult['Items'][number]) => item.Status === 'Failed' && !!item.Message)
      ?.Message
      ?.trim();

    if (!failureMessage) {
      return '';
    }

    return ['Primeiro erro:', this.formatFailureMessage(failureMessage)].join('\n');
  }

  private formatFailureMessage(message: string): string {
    try {
      const parsedMessage = JSON.parse(message) as { title?: string; detail?: string; status?: number; traceId?: string };
      const formattedMessage = [
        parsedMessage.title,
        parsedMessage.detail,
        parsedMessage.status ? `Status: ${parsedMessage.status}` : '',
        parsedMessage.traceId ? `TraceId: ${parsedMessage.traceId}` : ''
      ].filter(Boolean);

      if (formattedMessage.length > 0) {
        return formattedMessage.join('\n');
      }
    } catch {
      return message;
    }

    return message;
  }

  handleAfterSendEmail(response: any): void {

    let allBatchsSent = true;

    if (Array.isArray(response) && response.length > 0)
      allBatchsSent = response.every((sent: any) => sent == null || (sent != null && sent.allBatchsSent == true || sent.allBatchsSent == null))
    else
      allBatchsSent = response.allBatchsSent;

    if (allBatchsSent == true || allBatchsSent == null)
      this._snackbarService.openSnackBar('Disparo de e-mail realizado com sucesso!', 'success');
    else
      this._snackbarService.openSnackBar('Alguns lotes não foram enviados!', 'warning');

    this.checkedBatches = [];
    this.exceptionsBatches = [];
    this.checkAll = false;
    this.resetPagination();
  }

  resetPagination(): void {
    this.skip = 0;
  }

  orderChange(fields: IFieldOrder[]): void {
    this.fieldsOrder = [...fields];
    this.getBacthes(false, { Skip: 0, Take: this.skip + this.take });
  }

  resetDateValue(): void {
    this.batchDateFrom.setValue('');
    this.batchDateTo.setValue('');

    this.searchDateField();
  }

  getStorageFilter(): void {

    let bagSalva;

    if (this.mode === Mode.Invoicing) {
      bagSalva = localStorage.getItem('bag_i');
    } else if (this.mode === Mode.Transfer) {
      bagSalva = localStorage.getItem('bag_t');
    }
    let bag = JSON.parse(bagSalva || '{}');

    this.batchDateFrom.setValue(bag.dataIni);
    this.batchDateTo.setValue(bag.dataFim);
  }


}
